import Vue from 'vue'
import VueCookies from 'vue-cookies'
import App from './components/App/App.vue'
import router from './router'
import store from './store'
import { i18n } from './i18n/index'
import './utils/rounding'
import VueMeta from 'vue-meta'
import { analytics } from '@/utils/analytics'
import { setupHttpInterceptor } from '@/utils/httpInterceptor'
import { setupViewportScaler } from '@/utils/viewportScaler'

Vue.use(VueCookies)
Vue.use(VueMeta)

Vue.config.productionTip = false
Vue.prototype.$analytics = analytics

// Инициализируем HTTP interceptor для обработки 503 ошибок
setupHttpInterceptor()

// Масштабирование макета на краях диапазона ширин: фиксируем раскладку ниже
// 360px и увеличиваем её выше 2560px (RBXGD-1102). До монтирования приложения,
// чтобы первая же отрисовка шла в правильном режиме и не было скачка.
setupViewportScaler()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
